export const LOAD_METADATAURL_REQUEST = 'LOAD_METADATAURL_REQUEST';
export const LOAD_METADATAURL_REQUEST_FAIL = 'LOAD_METADATAURL_REQUEST_FAIL';
export const LOAD_METADATAURL_REQUEST_SUCCESS = 'LOAD_METADATAURL_REQUEST_SUCCESS';
export const SAVE_METADATAURL_REQUEST = 'SAVE_METADATAURL_REQUEST';
export const SAVE_METADATAURL_REQUEST_FAIL = 'SAVE_METADATAURL_REQUEST_FAIL';
export const SAVE_METADATAURL_REQUEST_SUCCESS = 'SAVE_METADATAURL_REQUEST_SUCCESS';
export const AUTH_SAVE_RESET = 'AUTH_SAVE_RESET';
